import { render, staticRenderFns } from "./ProjectGradeDialog.vue?vue&type=template&id=48244109&scoped=true"
import script from "./ProjectGradeDialog.vue?vue&type=script&lang=js"
export * from "./ProjectGradeDialog.vue?vue&type=script&lang=js"
import style0 from "./ProjectGradeDialog.vue?vue&type=style&index=0&id=48244109&prod&lang=css"
import style1 from "./ProjectGradeDialog.vue?vue&type=style&index=1&id=48244109&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48244109",
  null
  
)

export default component.exports